import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Package, MapPin, Heart } from "lucide-react";

export default function AccountOverview() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/account/orders").then((r) => r.data).catch(() => []),
      api.get("/account/wishlist").then((r) => r.data).catch(() => []),
      api.get("/account/addresses").then((r) => r.data).catch(() => []),
    ]).then(([o, w, a]) => { setOrders(o); setWishlist(w); setAddresses(a); });
  }, []);

  const totalSpent = orders.reduce((s, o) => s + (o.total || 0), 0);

  return (
    <div data-testid="account-overview" className="space-y-8">
      <div className="grid sm:grid-cols-3 gap-4">
        <div className="border border-white/10 p-5">
          <div className="overline">Orders</div>
          <div className="mt-2 font-display text-4xl">{orders.length}</div>
        </div>
        <div className="border border-white/10 p-5">
          <div className="overline">Total Spent</div>
          <div className="mt-2 font-display text-4xl">{formatINR(totalSpent)}</div>
        </div>
        <div className="border border-white/10 p-5">
          <div className="overline">Saved Items</div>
          <div className="mt-2 font-display text-4xl">{wishlist.length}</div>
        </div>
      </div>

      <div className="border border-white/10 p-6">
        <h3 className="font-display uppercase tracking-widest text-sm mb-4">Recent Order</h3>
        {orders.length === 0 ? (
          <p className="text-white/55 font-body text-sm">No orders yet. <Link to="/shop" className="text-[#D96A1B] hover:underline">Start shopping →</Link></p>
        ) : (
          <div className="flex items-center justify-between">
            <div>
              <div className="font-display tracking-tight">#{orders[0].order_number}</div>
              <div className="text-xs text-white/50 font-body">{orders[0].items.length} item(s) · {orders[0].status}</div>
            </div>
            <div className="font-display text-[#D96A1B] text-lg">{formatINR(orders[0].total)}</div>
          </div>
        )}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Link to="/account/orders" data-testid="quick-orders" className="border border-white/10 p-5 hover:border-[#D96A1B]/60 transition-colors flex items-center gap-4">
          <Package className="text-[#D96A1B]" />
          <div>
            <div className="font-display uppercase tracking-tight">Track Orders</div>
            <div className="text-xs text-white/50 font-body">View status of all your orders</div>
          </div>
        </Link>
        <Link to="/account/addresses" className="border border-white/10 p-5 hover:border-[#D96A1B]/60 transition-colors flex items-center gap-4">
          <MapPin className="text-[#D96A1B]" />
          <div>
            <div className="font-display uppercase tracking-tight">Manage Addresses</div>
            <div className="text-xs text-white/50 font-body">{addresses.length} saved</div>
          </div>
        </Link>
      </div>
    </div>
  );
}
